import AddIcon from "@mui/icons-material/Add";
import { ButtonProps } from "@mui/material";
import { AccessRightChecks } from "../../../../features/user/accessRightChecks";
import { CustomButton } from "../customButton/CustomButton";

export interface AddButtonProps extends ButtonProps {
  label: string;
  accessRightChecks?: AccessRightChecks;
  onClick: () => void;
  variant?: "contained" | "outlined" | "text";
}

const AddButton = ({
  label,
  accessRightChecks,
  onClick,
  variant = "outlined",
  ...rest
}: AddButtonProps) => {
  return (
    <CustomButton
      startIcon={<AddIcon />}
      variant={variant}
      accessRightChecks={accessRightChecks}
      onClick={(e) => {
        onClick();
        e.currentTarget.blur();
      }}
      {...rest}
      sx={{
        height: "36px",
        textTransform: "none",
        borderRadius: "18px",
        fontWeight: "700",
        fontSize: "14px",
        ...rest.sx,
      }}
    >
      {label}
    </CustomButton>
  );
};

export default AddButton;
